import { dispatcher, api } from 'react-structure-admin';

export const STORE_ORDERS = 'STORE_ORDERS';
export const STORE_ORDERS_REFRESH = 'STORE_ORDERS_REFRESH';

export const STORE_ORDERS_PUT_STATUS = 'STORE_ORDERS_PUT_STATUS';
export const STORE_ORDERS_PUT_STATUS_FINISHED =
  'STORE_ORDERS_PUT_STATUS_FINISHED';

export const STORE_ORDERS_POST_PAYMENT = 'STORE_ORDERS_POST_PAYMENT';
export const STORE_ORDERS_POST_PAYMENT_FINISHED =
  'STORE_ORDERS_POST_PAYMENT_FINISHED';

export const STORE_ORDERS_GET_PRODUCTS = 'STORE_ORDERS_GET_PRODUCTS';
export const STORE_ORDERS_GET_PRODUCTS_FINISHED =
  'STORE_ORDERS_GET_PRODUCTS_FINISHED';

export const STORE_ORDERS_GET = 'STORE_ORDERS_GET';
export const STORE_ORDERS_GET_FINISHED = 'STORE_ORDERS_GET_FINISHED';

export const refresh = () => (dispatch) => {
  dispatch(dispatcher.createAction(STORE_ORDERS_REFRESH, 'store-orders'));
};

export const updateStoreOrderStatus = (data) => async (dispatch) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'store-orders',
    actionType: STORE_ORDERS_PUT_STATUS,
    effect: async () => api.put('store-orders/status', data)
  });
};

export const postPayment = (data, onSuccess) => async (dispatch) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'store-orders',
    actionType: STORE_ORDERS_POST_PAYMENT,
    effect: async () => api.post('store-orders/payment', data),
    onSuccess
  });
};

export const GetProducts = (querySearch, onSuccess) => async (dispatch) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'store-orders',
    actionType: STORE_ORDERS_GET_PRODUCTS,
    effect: async () => api.get('store-orders', `products?${querySearch}`),
    onSuccess
  });
};

export const GetStoreOrder = (id, allowLoading, onSuccess) => async (
  dispatch
) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'store-orders',
    actionType: STORE_ORDERS_GET,
    payload: allowLoading,
    effect: async () => api.get('store-orders', id),
    onSuccess
  });
};
